import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getAccessLevel } from '../utils/accessControl';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [availableMenuItems, setAvailableMenuItems] = useState([]);
  const { userRole } = useAuth();

  // Update available menu items when user role changes
  useEffect(() => {
    if (userRole) {
      console.log('SidebarContext - User role changed:', userRole);
      const userLevel = getAccessLevel(userRole);
      console.log('SidebarContext - User access level:', userLevel);
    }
  }, [userRole]);

  const toggleSidebar = () => {
    setIsMobileOpen(prev => !prev);
  };

  return (
    <SidebarContext.Provider value={{ 
      isCollapsed,
      isMobileOpen,
      toggleSidebar,
      availableMenuItems,
      userRole
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
